<template lang="pug">
  .b2b-page-newuserexistdata
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('users.createuser.datauser.title', { username: modifyUserSession.username } ) }}
      ods-form(
        ref='userForm',
        :model='userForm',
        label-width='14rem',
        label-position='top',
        size='mini')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("users.createuser.datauser.name")',
              prop='name')
              ods-input(v-model='userForm.name', :disabled='true')
            ods-form-item(
              :label='$t("users.createuser.datauser.firstSurname")',
              prop='firstSurname')
              ods-input( v-model='userForm.firstSurname' :disabled='true')
            ods-form-item(
              :label='$t("users.createuser.datauser.secondSurname")',
              prop='secondSurname')
              ods-input( v-model='userForm.secondSurname', :disabled='true')
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("users.createuser.party.partyTaxIdentificationNumber")',
              prop='partyTaxIdentificationNumber')
              ods-input( v-model='userForm.partyTaxIdentificationNumber', :disabled='true')
    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          type='primary',
          @click='goEntitiesUser("userForm")')
          | {{ $t('buttons.btnNext') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-newuserexistdata',
  mixins: [Utils],
  data () {
    return {
      userForm: {}
    }
  },

  computed: {
    ...mapGetters([
      'modifyUserSession'
    ])
  },

  methods: {
    ...mapActions(['resetSession']),

    goEntitiesUser (formName) {
      // Emitimos el evento para pasar a líneas de factura en STEPS
      this.$emit('update', 2)
    },
    async getUserRolesAuthoritiesOnDatabase () {
      const dataQuery = {
        userId: this.userId,
        query: {
          projectId: this.projectSelectedRolesAuthorities
        }
      }
      try {
        const response = await this.getUserRolesAuthorities(dataQuery)
        this.userRolesAuthorities = response
      } catch (error) {
        console.log('getUserRolesAuthoritiesOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }

  },

  async created () {
    console.log('B2bNewUSerData', this.modifyUserSession)
    this.userForm = this.modifyUserSession.usuario
    this.userForm.partyTaxIdentificationNumber = this.modifyUserSession.partyTaxIdentificationNumber
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-newuserexistdata {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button {
      float: right;
    }

    ::v-deep .ods-module {
      &__body {
        padding: 0px;
      }
    }
  }
}
</style>
